import type {
  captureException,
  captureMessage,
  addBreadcrumb,
  setUser,
  setTag,
  setContext,
  getClient,
  init
} from '@sentry/vue';

export interface SentryModule {
  init: typeof init;
  captureException: typeof captureException;
  captureMessage: typeof captureMessage;
  addBreadcrumb: typeof addBreadcrumb;
  setUser: typeof setUser;
  setTag: typeof setTag;
  setContext: typeof setContext;
  getClient: typeof getClient;
}

// Global Sentry instance holder to avoid imports in components
let globalSentryInstance: SentryModule | null = null;

// Set the global Sentry instance
export function setGlobalSentry(sentry: SentryModule) {
  globalSentryInstance = sentry;
}

// Get the global Sentry instance
export function getGlobalSentry(): SentryModule | null {
  return globalSentryInstance;
}

